(function() {
  var SWATCH_UNIT = 25;
  var OVERFLOW_UNIT = 35;
  var MOBILE_BP = 768;
  var MOBILE_MAX_SWATCHES = 5;

  function calcLimit(container, total) {
    var w = container.getBoundingClientRect().width;
    if (w <= 0) return 0;
    var fit = Math.floor((w - OVERFLOW_UNIT) / SWATCH_UNIT);
    if (window.innerWidth < MOBILE_BP) {
      fit = Math.min(fit, MOBILE_MAX_SWATCHES);
    }
    return fit;
  }

  function swapImage(swatch, hoverImg) {
    var gridProduct = swatch.closest('.grid-product__content');
    if (!gridProduct) return;
    var img = gridProduct.querySelector('.grid-product__image-mask img');
    if (!img) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
      img.dataset.originalSrcset = img.srcset || '';
    }
    img.src = hoverImg;
    img.srcset = '';
    var sec = gridProduct.querySelector('.grid-product__secondary-image img');
    if (sec) {
      if (!sec.dataset.originalSrc) {
        sec.dataset.originalSrc = sec.src;
        sec.dataset.originalSrcset = sec.srcset || '';
      }
      sec.src = hoverImg;
      sec.srcset = '';
    }
  }

  function restoreImage(swatch) {
    var gridProduct = swatch.closest('.grid-product__content');
    if (!gridProduct) return;
    var img = gridProduct.querySelector('.grid-product__image-mask img');
    if (!img || !img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
    img.srcset = img.dataset.originalSrcset;
    var sec = gridProduct.querySelector('.grid-product__secondary-image img');
    if (sec && sec.dataset.originalSrc) {
      sec.src = sec.dataset.originalSrc;
      sec.srcset = sec.dataset.originalSrcset;
    }
  }

  var observer = new IntersectionObserver(function(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      var container = entries[i].target;
      observer.unobserve(container);

      var data;
      try {
        data = JSON.parse(container.getAttribute('data-swatch-data'));
      } catch (e) {
        continue;
      }

      var total = data.length;
      var limit = 0;
      if (container.hasAttribute('data-swatch-limit')) {
        var autoLimit = container.getAttribute('data-swatch-limit') === 'auto';
        if (autoLimit) {
          var maxFit = Math.floor(container.getBoundingClientRect().width / SWATCH_UNIT);
          var isMobile = window.innerWidth < MOBILE_BP;
          limit = (total > maxFit || isMobile) ? calcLimit(container, total) : 0;
        } else {
          limit = parseInt(container.getAttribute('data-swatch-limit'), 10) || 0;
        }
      }
      var renderCount = (limit > 0 && total > limit) ? limit : total;

      var frag = document.createDocumentFragment();
      for (var j = 0; j < renderCount; j++) {
        var s = data[j];
        var a = document.createElement('a');
        a.href = s.url;
        a.className = 'color-swatch color-swatch--small';
        a.setAttribute('aria-label', s.label);
        a.style.cssText = 'background-color:' + s.bg + ';' + (s.img ? 'background-image:url(' + s.img + ');' : '') + 'border-radius:20px;';
        if (s.hoverImg) {
          a.dataset.hoverImg = s.hoverImg;
          a.addEventListener('mouseenter', function() { swapImage(this, this.dataset.hoverImg); });
          a.addEventListener('mouseleave', function() { restoreImage(this); });
        }
        frag.appendChild(a);
      }

      if (limit > 0 && total > limit) {
        var overflow = document.createElement('a');
        overflow.className = 'swatch-overflow';
        overflow.href = data[0].url.split('?')[0];
        overflow.textContent = (total - limit) + '+';
        frag.appendChild(overflow);
      }

      container.appendChild(frag);
      container.removeAttribute('data-swatch-data');
    }
  }, { rootMargin: '200px' });

  function init() {
    var containers = document.querySelectorAll('[data-swatches-lazy]');
    for (var i = 0; i < containers.length; i++) {
      observer.observe(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
